import Vue from 'vue/dist/vue.min.js'
window.Vue = require('vue').default;

Vue.component('footer-component', require('./components/FooterComponent.vue').default);

if ($('#user-footer').length) {
    const userApp = new Vue({
        el: '#user-footer',
    });
}

